// Global variable to store the save and close function for the call fullscreen
let callFullScreenSaveAndClose: (() => Promise<void>) | null = null;

let sidePanelIsDirty: boolean = false;

export const setCallFullScreenSaveAndClose = (
  fn: (() => Promise<void>) | null
) => {
  callFullScreenSaveAndClose = fn;
};

export const getCallFullScreenSaveAndClose = ():
  | (() => Promise<void>)
  | null => {
  return callFullScreenSaveAndClose;
};

export const setSidePanelIsDirty = (isDirty: boolean) => {
  sidePanelIsDirty = isDirty;
};

export const getSidePanelIsDirty = (): boolean => {
  return sidePanelIsDirty;
};
